import React from 'react';
import clsx from 'clsx';

const styles = {
  base: [
    'relative overflow-hidden rounded-xl border bg-white shadow-sm',
    'dark:bg-zinc-900 dark:border-white/10 dark:shadow-zinc-950/50',
  ],
  padding: {
    none: '',
    sm: 'p-3 sm:p-4',
    md: 'p-4 sm:p-6',
    lg: 'p-6 sm:p-8',
  },
};

export const Card = ({ 
  className = '', 
  children, 
  padding = 'md',
  elevated = false,
  noBorder = false,
  as: Component = 'div', 
  ...props 
}) => {
  return (
    <Component
      className={clsx(
        styles.base,
        styles.padding[padding],
        elevated && 'shadow-md',
        noBorder && 'border-0',
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

// Card subcomponents
export const CardHeader = ({ className = '', children, divided = false, ...props }) => (
  <div
    className={clsx(
      'mb-4',
      divided && 'pb-4 border-b border-gray-200 dark:border-zinc-800',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export const CardTitle = ({ className = '', children, as: Component = 'h3', ...props }) => (
  <Component
    className={clsx(
      'text-lg font-semibold leading-tight text-gray-900 dark:text-white',
      className
    )}
    {...props}
  >
    {children}
  </Component>
);

export const CardDescription = ({ className = '', children, ...props }) => (
  <p
    className={clsx(
      'mt-1 text-sm text-gray-500 dark:text-gray-400',
      className
    )}
    {...props}
  >
    {children}
  </p>
);

export const CardContent = ({ className = '', children, ...props }) => (
  <div className={clsx('', className)} {...props}>
    {children}
  </div>
);

export const CardFooter = ({ className = '', children, divided = false, ...props }) => (
  <div
    className={clsx(
      'mt-4',
      divided && 'pt-4 border-t border-gray-200 dark:border-zinc-800',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export const CardSection = ({ 
  children, 
  className = '', 
  divider = true 
}) => (
  <div className={`
    ${divider ? 'border-t border-gray-200 mt-6 pt-6 first:border-0 first:mt-0 first:pt-0' : ''}
    ${className}
  `}>
    {children}
  </div>
);
